import styled from 'styled-components';
import { MOBILE, BLACK } from '../../theme';

const TypeformContainer = styled.div`
  position: relative;
  width: 100%;
  min-height: 45rem;
  @media (max-width: ${MOBILE}) {
    margin-left: -1rem;
  }
  iframe {
    min-height: 45rem;
  }
`;


const ConfirmationSubtext = styled.div`
  color: ${BLACK};
  text-align: center;
  max-width: 35.9rem;
`;

const ConfirmationFormTitle = styled.h3`
  text-align: center;
  font-size: 1.25rem;
  max-width: 41.25rem;
  margin: .5rem auto 1rem auto;
  font-family: Calistoga;
`;


export { TypeformContainer, ConfirmationFormTitle, ConfirmationSubtext };
